import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ALEXA_PHOTO } from "../config";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const About = () => {
  const { t } = useLang();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="about" data-testid="about" className="relative py-24 md:py-32 bg-[#080808] overflow-hidden">
      <div className="absolute -bottom-24 -left-24 w-[420px] h-[420px] rounded-full bg-[#d4af37]/8 blur-[120px] z-0" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Photo */}
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 rounded-3xl border border-[#d4af37]/25" />
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src={ALEXA_PHOTO}
                alt="Alexa Guzman, Founder and CEO of Alexa Financial Multiservices"
                className="w-full h-[500px] md:h-[620px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl px-6 py-4">
                <div className="font-display text-xl text-white">{t.about.name}</div>
                <div className="text-sm text-[#d4af37]">{t.about.role}</div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Copy */}
        <div className="lg:col-span-7">
          <Reveal><Eyebrow testId="about-eyebrow">{t.about.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.about.title1} <span className="text-gold-gradient italic">{t.about.title2}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-7 text-[#b3b3b3] text-base md:text-lg leading-relaxed max-w-2xl">{t.about.bio}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 grid grid-cols-2 gap-6 max-w-md">
              <div className="border-l border-[#d4af37]/40 pl-5">
                <div className="font-display text-3xl md:text-4xl text-gold-gradient">{t.about.stat1v}</div>
                <div className="text-sm text-[#a3a3a3] mt-1">{t.about.stat1}</div>
              </div>
              <div className="border-l border-[#d4af37]/40 pl-5">
                <div className="font-display text-3xl md:text-4xl text-gold-gradient">{t.about.stat2v}</div>
                <div className="text-sm text-[#a3a3a3] mt-1">{t.about.stat2}</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.4}>
            <button
              data-testid="about-cta"
              onClick={() => go("booking")}
              className="group mt-10 inline-flex items-center gap-2 rounded-full px-8 py-4 bg-[#d4af37] text-[#050505] font-medium hover:bg-[#e9d08a] transition-colors duration-300"
            >
              {t.nav.cta}
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
